import type { StandardResource, StandardResourceItem } from "../types";

function line(id: string, label: string, quantity: number, unit: string): StandardResourceItem {
  return { id, label, quantity, unit, rate: 0, hsnCode: "" };
}

/** Seed catalog migrated from former static list — editable under Standard resources master. */
export const initialStandardResources: StandardResource[] = [
  {
    id: "sr-cement",
    title: "Cement",
    notes: "",
    sortOrder: 1,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-cement-1", "Bags", 180, "Bag")],
  },
  {
    id: "sr-steel",
    title: "Steel",
    notes: "",
    sortOrder: 2,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-steel-1", "Reinforcement", 1400, "KG")],
  },
  {
    id: "sr-bricks",
    title: "Bricks",
    notes: "",
    sortOrder: 3,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-bricks-1", "Bricks", 7600, "Nos")],
  },
  {
    id: "sr-aggregate",
    title: "Aggregate",
    notes: "",
    sortOrder: 4,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-aggregate-1", "Coarse aggregate", 760, "Cu.ft")],
  },
  {
    id: "sr-sand",
    title: "Sand",
    notes: "",
    sortOrder: 5,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-sand-1", "Fine aggregate", 800, "Cu.ft")],
  },
  {
    id: "sr-flooring",
    title: "Flooring",
    notes: "",
    sortOrder: 6,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-flooring-1", "Flooring area", 400, "Sq.ft")],
  },
  {
    id: "sr-windows",
    title: "Windows",
    notes: "",
    sortOrder: 7,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-windows-1", "Glazing", 68, "Sq.ft")],
  },
  {
    id: "sr-doors",
    title: "Doors",
    notes: "",
    sortOrder: 8,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-doors-1", "Door openings / shutters", 72, "Sq.ft")],
  },
  {
    id: "sr-electrical",
    title: "Electrical fittings",
    notes: "",
    sortOrder: 9,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-electrical-1", "Points / area basis", 60, "Sq.ft")],
  },
  {
    id: "sr-painting",
    title: "Painting",
    notes: "",
    sortOrder: 10,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-painting-1", "Painted surface", 2400, "Sq.ft")],
  },
  {
    id: "sr-sanitary",
    title: "Sanitary fittings",
    notes: "",
    sortOrder: 11,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-sanitary-1", "Bath / WC fittings", 400, "Sq.ft")],
  },
  {
    id: "sr-kitchen",
    title: "Kitchen work",
    notes: "",
    sortOrder: 12,
    createdAt: "2026-01-01T00:00:00.000Z",
    items: [line("sri-kitchen-1", "Platform / units", 22, "Sq.ft")],
  },
];
